import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, change} from 'redux-form';

import {clearField} from 'utils/forms';
import {required} from 'utils/validators';
import FormField from 'components/FormField';
import Label from 'components/Label';
import ErrorBlock from 'components/ErrorBlock';
import {DropzoneField} from 'components/Fields';
import Dropzone from 'components/Dropzone';

import {uploadFile, ACCEPTED_FILE_TYPES} from 'ducks/files';
import {
  MODALS,
  verifyAffordabilityDocumentUpload,
  fetchAffordability
} from 'ducks/bookings';
import {storeDataInModal, selectModal} from 'ducks/modals';

import {affordabilityDocumentSign} from 'sdk/bookings';

const formSubmit = (values, dispatch, props) => {
  const {bookingId, affordabilityId} = props;

  const fetchAffordabilityExtraAction = () =>
    fetchAffordability({bookingId, affordabilityId}, [
      affordability =>
        storeDataInModal({
          modalName: MODALS.AFFORDABILITY_DETAIL,
          data: {affordability}
        })
    ]);

  const extraActions = [
    ...props.getExtraActions(),
    fetchAffordabilityExtraAction
  ];

  const data = {
    identifier: values.poiDocument,
    bookingId,
    affordabilityId
  };

  dispatch(verifyAffordabilityDocumentUpload(data, extraActions));
};

class AffordabilityDocumentUploadForm extends React.Component<any> {
  state = {
    files: []
  };

  removeFile = () =>
    this.setState({files: []}, () => clearField(this, {field: 'poiDocument'}));

  onFileDrop = files => {
    const storeIdentifierAction = identifier =>
      change('affordabilityDocumentUpload', 'poiDocument', identifier);

    const startUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.AFFORDABILITY_DOCUMENT_UPLOAD,
        data: {
          uploading: true
        }
      });

    const finishUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.AFFORDABILITY_DOCUMENT_UPLOAD,
        data: {
          uploading: false
        }
      });

    const file = files[0];
    const signSdk = affordabilityDocumentSign;
    const signData = {
      filename: file.name,
      fileType: file.type,
      owner: this.props.agreementUserId
    };
    this.setState({files: files}, () =>
      this.props.uploadFile({
        file,
        signSdk,
        signData,
        startUploadingAction,
        finishUploadingAction,
        storeIdentifierAction
      })
    );
  };

  render() {
    const {error, uploading} = this.props;
    const {files} = this.state;

    return (
      <form>
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <div className="colab-centered-h">
          <FormField>
            <Label className="colab-centered-h">POI Document</Label>
            <Field
              name="poiDocument"
              validate={[required]}
              component={DropzoneField}
              onFileDrop={this.onFileDrop}
              removeFile={this.removeFile}
              multiple={false}
              uploading={uploading}
              files={files}
              acceptedFileTypes={ACCEPTED_FILE_TYPES}
              previewType={Dropzone.LARGE}
            />
          </FormField>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const {data: {uploading}} = selectModal(
    state,
    MODALS.AFFORDABILITY_DOCUMENT_UPLOAD
  );

  return {
    uploading
  };
};

const mapDispatchToProps = {
  uploadFile
};

const affordabilityDocumentUploadForm = reduxForm({
  form: 'affordabilityDocumentUpload',
  onSubmit: formSubmit,
  enableReinitialize: true
})(AffordabilityDocumentUploadForm);

export default connect(mapStateToProps, mapDispatchToProps)(
  affordabilityDocumentUploadForm
);
